import React, { useMemo } from "react";
import NotFoundParallax from "./not-found/NotFoundParallax";
import { useCurrentCampaign } from "../hooks/currentCampaign";

const Backpannel = ({ mode, children }) => {
  const { campaign } = useCurrentCampaign();

  const backgroundImageObj = {
    corral: [
      "/background-images/central-galvion.png",
      "/background-images/west-galvion.png",
      "/background-images/ozymandias.png",
    ],
    vestillion: [
      "/background-images/nelic-embrace.png",
      "/background-images/attris.png",
    ],
  };

  const chooseBackgroundImage = (campaignCode) => {
    if (backgroundImageObj[campaignCode]) {
      const arr = backgroundImageObj[campaignCode];
      return arr[Math.floor(Math.random() * arr.length)];
    }
    if (campaignCode === "all") {
      const arr = Object.values(backgroundImageObj).flat();
      return arr[Math.floor(Math.random() * arr.length)];
    }
    return null;
  };

  const backgroundUrl = useMemo(
    () => chooseBackgroundImage(campaign?.code),
    [campaign?.code],
  );

  const style = backgroundUrl
    ? {
        minHeight: "100vh",
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("${backgroundUrl}")`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top center",
      }
    : { minHeight: "100vh" };

  return (
    <div className="app-body" style={style}>
      {mode === "404" && <NotFoundParallax />}
      {children}
    </div>
  );
};

export default Backpannel;
